// extracted by mini-css-extract-plugin
export default {"loader":"TranslatePartnerSectionModal_loader__K+WCH","error":"TranslatePartnerSectionModal_error__9yN84"};